import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
let promise = Promise.all([parcelRequire.load("dvJA0")]).then(() => {
let originalModule = parcelRequire("2JLKP");
let resources = <link rel="modulepreload" href={parcelRequire.resolve("dvJA0")} />;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
